import React from 'react'
import {connect} from 'react-redux'
import {WeixinApi, AudioPlayer} from './components'
import {WKGlobalTopTip} from './components/wk'
import axios from 'axios'
import Stats from './components/Stats'
import {setToken, storage, setAccessToken} from './utils'
import Config from './config'
import {Toast} from 'react-weui'
import './styles/root.css'
import Raven from 'raven-js'

class Root extends React.Component {
    componentDidMount(){
        if(this.props.location.pathname.indexOf('/account/auth/') === 0){
            return
        }
        axios.get('/api/account/self').then((response) => {
            if(response.data.code === 0) {
                localStorage.setItem('lzwk_id', Number(response.data.data.id));
            
                this.props.dispatch({
                    type: 'ACCOUNT_LOAD',
                    payload: response.data.data
                });
            
                window.gio && window.gio('setUserId', response.data.data.id);
            
                Raven.setUserContext(response.data.data)
            }
        }).catch((error) => {
            console.log('failed to load self, error=', error);
        });

        if(!window._wk_toast) {
            //  全局公用toast组件，同一时间只会存在一个实例
            //  自己控制组件消失
            //  组件出现window._wk_toast.show('提示', 'https://...(ICON链接,可以不传,有默认ICON)')
            //  组件消失window._wk_toast.hide()
            //  组件自行消失
            //  组件出现window._wk_toast.show('提示', 'https://...', 1000)
            window._wk_toast = Object.create(null)
            let toast = window._wk_toast
            let target = document.querySelector('#wk__toast-global')
            let content = target.querySelector('.weui-toast_content')

            toast.timeout = null
            toast.show = (text, img, t) => {
                if (toast.timeout) {
                    return
                }

                if (!t) toast.timeout = 'wk'

                target.style.display = 'block'
                if (img !== 'none') {
                    let image = new Image()
                    image.src = img || 'https://static-1253442168.image.myqcloud.com/picture/5459246_033f6f23e8b8dcb86d2e6b9d24b68c5f.jpg'
                    if (img === 'success') {
                        image.src = 'https://static-1253442168.image.myqcloud.com/picture/6163375_44f39869696b2cc81f4da8420a86c414.jpg'
                    }
                    if (img === 'info') {
                        image.src = 'https://static-1253442168.image.myqcloud.com/picture/5459246_033f6f23e8b8dcb86d2e6b9d24b68c5f.jpg'
                    }
                    content.appendChild(image)
                }
                let span = document.createElement('span')
                if (/__br/.test(text)) {
                    let list = text.split('__br')
                    list.forEach((n, index) => {
                        let s = document.createElement('span')
                        s.innerHTML = n
                        content.appendChild(s)
                        if (index === 0) {
                            let br = document.createElement('br')
                            br.innerHTML =  "<br/>"
                            content.appendChild(br)
                        }
                    })
                } else {
                    span.innerHTML = text
                    content.appendChild(span)
                }

                if (t) {
                    toast.timeout = setTimeout(() => {
                        target.style.display = 'none'
                        content.innerHTML = ''
                        toast.timeout = null
                    }, t)
                }
            }
            toast.hide = () => {
                target.style.display = 'none'
                content.innerHTML = ''
                toast.timeout = null
            }
        }
    }

    render(){
        return <div>
          	<WeixinApi />
            <AudioPlayer />
            <Stats />
            <div id="wk__toast">
                <Toast show={this.props.global_component.toastShow}>
                    <img src="https://static-1253442168.image.myqcloud.com/picture/5459246_033f6f23e8b8dcb86d2e6b9d24b68c5f.jpg"/>
                    {this.props.global_component.toastMain}
                    <br/>
                    {this.props.global_component.toastSub}
                </Toast>
            </div>
            <div id="wk__toast-global">
                <Toast show={true}>

                </Toast>
            </div>
             {/* <WKGlobalTopTip />  */}
        	{this.props.children}
            {
                /iphone/gi.test(navigator.userAgent) && (screen.height === 812 && screen.width === 375) && / qq\//.test(navigator.userAgent.toLowerCase()) && <div className="iphonex-bottom"></div>
            }

        </div>
    }
}


export default connect((state) => ({
	account: state.account,
    global_component: state.global_component,
}))(Root)



// WEBPACK FOOTER //
// ./src/Root.js